export default "__VITE_ASSET__BRS_g75U__"